import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { Loader } from '@/components/loaders/loader';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface UpdatingProps {
  isOpen: boolean;
}

const Updating = ({ isOpen }: UpdatingProps) => {
  return (
    <ModalWrappedContent isOpen={isOpen} onClose={() => null} showCloseIcon={false} showCancelButton={false}>
      <ModalBody>
        <Loader size={70} />
        <ModalTitle>Updating</ModalTitle>
        This may take a few moments.
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default Updating;

const ModalTitle = styled.div`
  color: ${themeVar('font.strong')};
  text-align: center;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
`;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  margin: 23px 0 23px 0;
  font-size: 19px;
  font-weight: 400;
  line-height: 26.6px;
  color: ${themeVar('font.base')};
`;
